import { Book } from "./book";
import React from "react";

export const Thriller = (props) => {
  return (
    <div id="thriller" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Thriller</h2>
          <p>Bisher erschienene Thriller</p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-4 col-md-4 col-lg-4"
                  >
                    <Book
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                      langtext={d.langtext}
                    />
                    <div id={d.bodShop}>&nbsp:</div>
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
